module.exports = __webpack_public_path__ + "img/conduct.1b8d5337.jpg";